import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { useFeature } from "~/core/composables/useFeature";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { AppFeatures } from "~/core/models/AppFeatures.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import {
  PATH_CAMPAIGNS,
  PATH_CAMPAIGNS_UID,
} from "~/modules/campaign/constants";
import CampaignOperationMgrDetailPage from "~/modules/campaign/views/CampaignOperationMgrDetailPage.vue";
import CampaignsPage from "~/modules/campaign/views/CampaignsPage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_CAMPAIGNS,
    component: CampaignsPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.CAMPAIGN,
    },
  },
  {
    path: PATH_CAMPAIGNS_UID,
    component: CampaignOperationMgrDetailPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.CAMPAIGN,
    },
  },
];

export default routes;
